/**
 * Vocabulario UNICO de origem/meio da plataforma.
 *
 * Atribuicao so soma quando todo mundo grava a dimensao do mesmo jeito: se o
 * cadastro manual grava `indicacao/referral` e a landing page grava
 * `Indicação / Referral`, o relatorio quebra a mesma origem em duas linhas.
 * Por isso origem e meio saem SEMPRE daqui (ou passam por normalizeDimension).
 */

// minusculo, sem espaco — o formato que o CRM ja grava desde a conversao manual
export const normalizeDimension = value =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-');

// Origens offline/relacionamento — espelham os tipos da conversao manual
// (ManualConversionModal), pra um lead de indicacao cair igual nos dois lugares.
export const MANUAL_TRAFFIC_TYPES = [
  { key: 'INDICACAO', source: 'indicacao', medium: 'referral' },
  { key: 'MIDIA_OFFLINE', source: 'midia-offline', medium: 'offline' },
  { key: 'EVENTO', source: 'evento', medium: 'offline' },
  { key: 'WALK_IN', source: 'walk-in', medium: 'offline' },
  { key: 'PARCERIA', source: 'parceria', medium: 'referral' },
];

// Origens digitais — usadas para montar links rastreados de landing page.
export const DIGITAL_TRAFFIC_TYPES = [
  { key: 'INSTAGRAM_ORGANICO', source: 'instagram', medium: 'social' },
  { key: 'INSTAGRAM_BIO', source: 'instagram', medium: 'bio' },
  { key: 'META_ADS', source: 'facebook', medium: 'paid_social' },
  { key: 'GOOGLE_ADS', source: 'google', medium: 'cpc' },
  { key: 'GOOGLE_ORGANICO', source: 'google', medium: 'organic' },
  { key: 'TIKTOK_ADS', source: 'tiktok', medium: 'paid_social' },
  { key: 'TIKTOK_ORGANICO', source: 'tiktok', medium: 'social' },
  { key: 'YOUTUBE', source: 'youtube', medium: 'social' },
  { key: 'WHATSAPP', source: 'whatsapp', medium: 'message' },
  { key: 'EMAIL', source: 'email', medium: 'email' },
  { key: 'QR_CODE', source: 'qr-code', medium: 'offline' },
];

// Escape hatch: destrava os campos pra quem sabe o que esta fazendo.
export const CUSTOM_TRAFFIC_TYPE = {
  key: 'PERSONALIZADO',
  source: '',
  medium: '',
  custom: true,
};

export const LANDING_PAGE_TRAFFIC_TYPES = [
  ...DIGITAL_TRAFFIC_TYPES,
  ...MANUAL_TRAFFIC_TYPES,
  CUSTOM_TRAFFIC_TYPE,
];

// Monta a URL rastreada a partir da base + dimensoes (sempre normalizadas).
export const buildTrackedUrl = (baseUrl, dimensions) => {
  if (!baseUrl) return '';
  const params = new URLSearchParams();
  [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ].forEach(key => {
    const value = normalizeDimension(dimensions[key]);
    if (value) params.append(key, value);
  });
  const query = params.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
};
